import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { ComponentTheme } from '@helpers/themeEnum';
import { h4, paragraph, paragraphLarge } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  --listBgColour: ${brand.grey.grey16};
  --listFgColour: ${brand.white};
  --iconCardBg: ${brand.white};
  --cardFgColor: ${brand.grey.grey16};

  padding-top: ${fluid(80, 90)};
  padding-bottom: ${fluid(80, 120)};
  background-color: var(--listBgColour);
  color: var(--listFgColour);

  &[data-theme=${ComponentTheme.Orange}] {
    --listBgColour: ${brand.orange.base};
  }

  &[data-theme=${ComponentTheme.Yellow}] {
    --listBgColour: ${brand.yellow.base};
  }

  &[data-theme=${ComponentTheme.Green}] {
    --listBgColour: ${brand.green.base};
  }

  &[data-theme=${ComponentTheme.Blue}] {
    --listBgColour: ${brand.blue.base};
  }

  &[data-theme=${ComponentTheme.Green}],
  &[data-theme=${ComponentTheme.Blue}],
  &[data-theme=${ComponentTheme.Orange}],
  &[data-theme=${ComponentTheme.Yellow}] {
    --listFgColour: ${brand.grey.grey16};
  }
`;
const Inner = styled.div `
  ${siteWide};
`;
const TitleArea = styled.div `
  @media ${from(Device.Tablet)} {
    ${baseGrid};
  }
`;
const Title = styled.h2 `
  ${h4};

  @media ${from(Device.Tablet)} {
    grid-column: span 6;
  }
`;
const SubTitle = styled.p `
  ${paragraph};
  margin-top: 18px;

  @media ${from(Device.Tablet)} {
    grid-column: 8 / span 5;
  }
`;
const IconListing = styled.div `
  ${baseGrid};
  row-gap: var(--gutterWidth);
  grid-template-columns: repeat(1, 1fr);
  padding-top: ${fluid(12, 58)};

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const IconCard = styled.article `
  background-color: ${brand.white};
  border-radius: ${fluid(25, 50)};
  overflow: hidden;
  color: var(--cardFgColor);
  background-color: var(--iconCardBg);

  @media ${from(Device.DesktopSmall)} {
    display: flex;
  }
`;
const IconCardContent = styled.div `
  padding: ${fluid(32, 56)};
  padding-right: 58px;

  @media ${from(Device.DesktopSmall)} {
    padding: ${fluid(32, 56)} ${fluid(32, 56)} ${fluid(32, 56)} ${fluid(32, 40)};
  }
`;
const IconCardTitle = styled.h3 `
  ${paragraphLarge};
  margin-bottom: ${fluid(7, 12)};
  ${fonts.montserrat.medium};
`;
const IconCardParagraph = styled.p `
  ${paragraph};
  margin-bottom: 0;
`;
const IconCardImage = styled.aside `
  display: none;
  align-items: center;
  flex-shrink: 0;

  @media ${from(Device.DesktopSmall)} {
    display: flex;
    flex: 0 0 200px;
  }
`;
const IconCardImageIcon = styled.img ``;
const MobileIconCardImage = styled.aside `
  padding-bottom: 48px;

  @media ${from(Device.DesktopSmall)} {
    display: none;
  }

  img {
    max-width: none;
    width: 100%;
  }
`;
export const IconListStyles = {
    Container,
    IconCard,
    IconCardContent,
    IconCardImage,
    IconCardImageIcon,
    IconCardParagraph,
    IconCardTitle,
    IconListing,
    Inner,
    MobileIconCardImage,
    SubTitle,
    TitleArea,
    Title,
};
